import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_player-captions-off",
  "use": "icon_player-captions-off-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon_player-captions-off\"><path stroke=\"currentColor\" stroke-linecap=\"square\" d=\"M10.5 5H21v10.5M17 11h-2.5m4 8H3V5h1.5M2 2l20 20M7 11h3.5M7 15h2.5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol